import {Component, signal, inject, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog"
import {MatInputModule} from "@angular/material/input"
import {MatSelectModule} from "@angular/material/select"
import {MeasurementType, MeasurementTypes} from "@common/models/settings/settings"
import {Labels} from "@labels"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-upload-texture-displacement-dialog",
    templateUrl: "./upload-texture-displacement-dialog.component.html",
    styleUrls: ["./upload-texture-displacement-dialog.component.scss"],
    imports: [MatDialogModule, MatInputModule, FormsModule, MatSelectModule, MatButtonModule],
})
export class UploadTextureDisplacementDialogComponent {
    readonly $result = signal<Partial<UploadTextureDisplacementDialogResult>>({
        displacement: undefined,
    })
    readonly dialogRef = inject(MatDialogRef<UploadTextureDisplacementDialogComponent>)
    readonly data = inject<{displacement?: number; measurementType?: MeasurementType}>(MAT_DIALOG_DATA)

    constructor() {
        if (this.data) {
            this.$result.set({
                displacement: this.data.displacement,
            })
            this.$imperial.set(this.data.measurementType === MeasurementTypes.Imperial)
        }
    }

    cancelAction(): void {
        this.dialogRef.close(false)
    }

    confirmAction(): void {
        if (this.$result().displacement && this.$imperial()) {
            this.$result.update((current) => ({...current, displacement: MeasurementTypes.Imperial.convertToMetric(current.displacement!)}))
        }
        this.dialogRef.close(this.$result())
    }

    protected readonly Labels = Labels

    readonly $imperial = signal(false)
}

export type UploadTextureDisplacementDialogResult = {
    displacement: number
}
